// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_-0O9V","nav":"index_nav_ku-3L","title":"index_title_kkXBA","close":"index_close_B6h4p","comment":"index_comment_Xd2-E"};